// Shared types/helpers for the homepage funnel tabs rendered under the core
// homepage header on the terms pages (see App.tsx). The rendering is composed
// in the portal shell rather than baked into the b2bportal header so the shell
// controls which routes show the tabs.

export type FunnelTabConfigLike = {
  id: string;
  route?: string;
  enabled?: boolean;
};

// Funnel enum values (from @b2bportal/core-types) used as funnel tab ids.
export const PREMIUM_STAYS_FUNNEL_ID = "PremiumStays";
export const CRUISES_FUNNEL_ID = "Cruises";

// Mirrors the homepage `useHeroTabs` gating: the PremiumStays tab shows only
// when the premier or lifestyle stays experiment is available, and the Cruises
// tab shows unless the cruises experiment is in control.
export const filterFunnelTabs = (
  tabs: FunnelTabConfigLike[],
  options: { isPremiumStaysAvailable: boolean; isCruisesAvailable: boolean }
) =>
  tabs.filter((tab) => {
    if (tab.id === PREMIUM_STAYS_FUNNEL_ID) {
      return options.isPremiumStaysAvailable;
    }
    if (tab.id === CRUISES_FUNNEL_ID) {
      return options.isCruisesAvailable;
    }
    return true;
  });
